export interface ReportReadinessInput {
  phase?: number | string | null;
  status?: string | null;
  package?: string | null;
  report?: ReportReadinessInput | string | null;
  dueDiligence?: ReportReadinessInput | null;
}

/**
 * A completed report is one that reached the automated delivery phase and
 * was explicitly completed by the backend. Phase 6 was populated manually
 * on legacy records and must not make a report available to customers.
 */
export function isReportReady(report: ReportReadinessInput | null | undefined): boolean {
  return [report, report?.report, report?.dueDiligence].some(candidate =>
    typeof candidate === 'object' && Number(candidate?.phase) === 5 && candidate?.status?.trim().toUpperCase() === 'COMPLETED'
      || typeof candidate === 'object' && Number(candidate?.phase) === 6 && candidate?.status?.trim().toUpperCase() === 'COMPLETED'
        && (candidate?.package?.toUpperCase() === 'R12' || candidate?.report === 'R12')
  );
}
